<template>
  <Tag
    v-for="name in driverAccountDisplayNames"
    :key="'dcell' + plantJson.id + name"
    class="mr-1 my-1"
  >
    {{ name }}
  </Tag>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { PlantJson } from '@/data/plants/PlantJson.ts';

export default {
  name: 'DriverAccountsCell',
  props: {
    plantJson: { type: Object as PropType<PlantJson>, required: true },
  },
  computed: {
    driverAccountDisplayNames() {
      if (!this.plantJson.meters) {
        return new Set();
      }

      const allDisplayNames = this.plantJson.meters
        .filter((m) => m.driver_account_id !== null)
        .flatMap((meter) => meter.driver_account)
        .map((driverAccount) => driverAccount.display_name);
      return new Set(allDisplayNames); // makes them unique
    },
  },
};
</script>

<style scoped></style>
